import React from 'react';
import ConfirmModal from './ConfirmModal';

const PAGE_LEAVE_MESSAGE = (
  <>
    취소 시 작성 중인 모든 변경 사항이 사라지며
    <br />
    이 작업은 취소할 수 없습니다.
  </>
);

const PageLeaveConfirmModal = ({
  isOpen,
  title = '정말로 나가시겠습니까?',
  cancelText = '취소하기',
  confirmText = '나가기',
  onCancel,
  onConfirm,
  canCloseOutside = false,
}) => (
  <ConfirmModal
    isOpen={isOpen}
    type="warning"
    title={title}
    message={PAGE_LEAVE_MESSAGE}
    showCancel
    cancelText={cancelText}
    confirmText={confirmText}
    onCancel={onCancel}
    onConfirm={onConfirm}
    canCloseOutside={canCloseOutside}
    size="sm"
    align="dialog"
  />
);

export default PageLeaveConfirmModal;
